import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IconButton, Tooltip, Box, Typography } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import { HelperResponsivo } from "./styles";

export const SupportLogo: React.FC = () => {
  const [opcao1, setOpcao1] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Verifica se a rota atual termina com "/itbi/imovel/" ou "/itbi/imovel-rural/"
    const opcao =
      window.location.href.indexOf("/itbi/imovel/") == -1 &&
      window.location.href.indexOf("/itbi/imovel-rural/") == -1;

    setOpcao1(opcao);
  }, [location]);

  return opcao1 ? (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        padding: "8px",
        borderRadius: "24px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <HelperResponsivo>
      <Tooltip title="Suporte">
        <a
          href="https://wa.me/5433431167"
          target="_blank"
          style={{
            textDecoration: "none",
            color: "inherit",
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconButton color="primary">
            <PhoneIcon />
          </IconButton>
          <Typography variant="body1" sx={{ ml: 1, color: "primary.main" }}>
            Suporte
          </Typography>
        </a>
      </Tooltip>
      </HelperResponsivo>
    </Box>
  ) : (
    <Box
      sx={{
        position: "fixed",
        bottom: 50,
        left: 16,
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        padding: "8px",
        borderRadius: "24px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
       <HelperResponsivo>
      <Tooltip title="Suporte">
        <a
          href="https://wa.me/5433431167"
          target="_blank"
          style={{
            textDecoration: "none",
            color: "inherit",
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconButton color="primary">
            <PhoneIcon />
          </IconButton>
          <Typography variant="body1" sx={{ ml: 1, color: "primary.main" }}>
            Suporte
          </Typography>
        </a>
      </Tooltip>
      </HelperResponsivo>
    </Box>
  );
};
